import { z } from 'zod/v4';

export const vehicleStatsSchema = z.object({
  vehicleId: z.number(),
  vehicleName: z.string(),
  vehicleGroups: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        numberOfVehicles: z.number(),
        numberOfRoutingProfiles: z.number(),
        hasConfigurationSettings: z.boolean(),
      })
    )
    .nullable(),
});

export type VehicleStats = z.infer<typeof vehicleStatsSchema>;
